import { createSSRApp } from 'vue';
import {
  initialState,
  mutations,
  actions,
  getters,
  DetailsPageContainer,
  initializePinia,
} from '@rei/product-page';
import Vuex from 'vuex';

export default function createApp(model) {
  const state = { ...initialState, ...model };
  const app = createSSRApp(DetailsPageContainer);
  const vuexStore = Vuex.createStore({
    state,
    mutations,
    actions,
    getters,
    devtools: typeof window !== 'undefined',
  });
  app.use(vuexStore);
  if (model.appProps['frontend.launch.toggles']?.enablePinia) initializePinia(app, model);

  return { app };
}
